import React from 'react'
import { ChevronRight } from 'react-feather'
import { Link } from 'react-router-dom'

const Breadcrumb = ({routes, className, color}) => {
  return (
    <div className={`flex items-center text-xs ${color ? '' : 'opacity-50'} ${className}`} style={{color}}>
      {
        routes.map((r, index) => (
          <React.Fragment key={index}>
            <Link className="mr-2" to={r.route}>{r.name}</Link>
            <ChevronRight style={{width: '14px', height: '14px'}} className="mr-2" />
          </React.Fragment>
        ))
      }
    </div>
  )
}

export { Breadcrumb }